export const EmpAllowanceAndDeductionsColumnMap = {
  "Employee No": "employeeCode",
  Employee: "employeeName",
  Type: "adjType",
  "Addition/Deduction Type": "adjName",
  Department: "departmentCode",
  Amount: "amount",
  "Addition/Deduction Date": "effectiveDateFrom",
};
